import { jsx, jsxs } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { FormOnColor, AnalyticsId, IconSize, AVERAGE_CHARACTER_WIDTH_PX } from "./constants.js";
import { useUuid } from "./hooks/useUuid.js";
import { getColor } from "./theme/currys/color.js";
import { getAriaDescribedBy } from "./utils/accessibility.js";
import { E as ErrorWrapper } from "./ErrorWrapper.js";
import { I as Icon } from "./Icon.js";
import ChevronDown from "./components/Icons/ChevronDown.js";
import { a as renderLabel } from "./Label.js";
import selectStyles from "./components/Select/styles.module.scss";
const getSelectMaxWidth = (characters) => {
  const paddingWidth = "2rem";
  return `calc(${characters * AVERAGE_CHARACTER_WIDTH_PX}px + ${paddingWidth})`;
};
const getIconColor = (invalid, disabled) => {
  const iconColor = invalid ? "cherry" : "blueberry";
  return disabled ? getColor("neutral", 500) : getColor(iconColor, 600);
};
const Select = React__default.forwardRef(function SelectForwardedRef(props, ref) {
  const {
    className,
    children,
    concept = "normal",
    disabled,
    error,
    errorText,
    errorTextId,
    errorWrapperClassName,
    label,
    selectId,
    name = selectId,
    onColor = FormOnColor.onwhite,
    testId,
    width,
    required,
    value,
    defaultValue,
    autoComplete = "off",
    wrapperClassName,
    ...rest
  } = props;
  const uuid = useUuid(selectId);
  const errorTextUuid = useUuid(errorTextId);
  const onBlueberry = onColor === "onblueberry";
  const invalid = onColor === "oninvalid" || !!errorText || !!error;
  const iconColor = getIconColor(invalid, !!disabled);
  const maxWidth = width ? getSelectMaxWidth(width) : void 0;
  const selectInnerWrapperClasses = classNames(
    selectStyles["select-inner-wrapper"],
    {
      [selectStyles["select-inner-wrapper--transparent"]]: concept === "transparent",
      [selectStyles["select-inner-wrapper--on-blueberry"]]: onBlueberry,
      [selectStyles["select-inner-wrapper--invalid"]]: invalid,
      [selectStyles["select-inner-wrapper--disabled"]]: disabled
    },
    className
  );
  const selectClasses = classNames(selectStyles.select, {
    [selectStyles["select--on-blueberry"]]: onBlueberry,
    [selectStyles["select--invalid"]]: invalid
  });
  const selectWrapperClasses = classNames(selectStyles["select-wrapper"], wrapperClassName);
  return /* @__PURE__ */ jsx(ErrorWrapper, { className: errorWrapperClassName, errorText, errorTextId: errorTextUuid, children: /* @__PURE__ */ jsxs("div", { "data-testid": testId, "data-analyticsid": AnalyticsId.Select, className: selectWrapperClasses, style: { maxWidth }, children: [
    renderLabel(label, uuid, onColor),
    /* @__PURE__ */ jsxs("div", { className: selectInnerWrapperClasses, "data-testid": testId + "-inner-wrapper", children: [
      /* @__PURE__ */ jsx(
        Icon,
        {
          className: selectStyles["select-arrow"],
          svgIcon: ChevronDown,
          color: iconColor,
          size: IconSize.XSmall,
          testId: testId + "-icon"
        }
      ),
      /* @__PURE__ */ jsx(
        "select",
        {
          "aria-invalid": !!invalid,
          id: uuid,
          name,
          className: selectClasses,
          disabled,
          ref,
          required,
          "aria-describedby": getAriaDescribedBy(props, errorTextUuid),
          "aria-required": !!required,
          value,
          defaultValue,
          autoComplete: autoComplete ? autoComplete : void 0,
          ...rest,
          children
        }
      )
    ] })
  ] }) });
});
export {
  Select as S
};
//# sourceMappingURL=Select.js.map
